
<div id="userProfile" class="page-layout carded  fullwidth" fxLayout="column">
  <ngx-loading [show]="loading"></ngx-loading>
  <!-- HEADER -->
  <div class="header accent p-24 h-70" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutAlign="center start" style="width: 100%">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="secondary-text s-18">home</mat-icon>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <span class="secondary-text">Nomenclatoare</span>
      </div>
      <div class="h1 mt-16" style="width: 100%">

       Utilizatori

        <span style="float: right;">
            <button mat-fab color="warn" aria-label="Adauga nou utilizator nou" (click)="onAddNewEntity()">
              <mat-icon>supervisor_account</mat-icon>
            </button>
        </span>

      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <div class="content p-24">
    <div class="mat-elevation-z8">
      <div style="max-width: 100%!important;">
        <mat-card fxFlex="100" class="mt-10">

          <mat-card-content>
            <table mat-table matSort  [dataSource]="dataSource" style="width: 100%">
              <ng-container *ngFor="let column of columns" matColumnDef="{{column.key}}">
                <th mat-header-cell *matHeaderCellDef> {{column.label}} </th>
                <td mat-cell *matCellDef="let element">
                  {{ formatValue( getElementValue(element, column.key), column.type) }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
              <tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"  (click)="onRowSelect(row)"></tr>
            </table>
          </mat-card-content>

          <mat-card-actions style="text-align: right; padding: 10px">
            <mat-paginator showFirstLastButtons [length]="tableResponseModel.total" [pageSize]="tableResponseModel.per_page" [pageIndex]="tableRequestModel.page"    [pageSizeOptions]="[5, 10, 20]"  (page)="onPageChange($event)"></mat-paginator>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>

</div>


